import { isBefore } from 'date-fns';
import { Scalar } from 'flatfile-csv-importer';
import { IDataHookRecord } from 'flatfile-csv-importer/build/main/obj.validation-response';
import { parsePhoneNumber } from 'libphonenumber-js';

const arbitraryDateWeThinkNothingWillHappenBefore = new Date(2010, 1, 1);

export function fieldToDate(values: [Scalar, number][], meta: any): [IDataHookRecord, number][] {
  return values.map(([value, row]) => {
    if (!value) {
      return [{ value: '' }, row];
    }
    const asNumber = +value;
    if (!isNaN(asNumber)) {
      let valueClone = asNumber;
      let date = new Date(valueClone);
      while (isBefore(date, arbitraryDateWeThinkNothingWillHappenBefore)) {
        valueClone = valueClone * 1000;
        date = new Date(valueClone);
      }
      return [{ value: date.toISOString() }, row];
    }
    if (typeof value === 'string') {
      return [{ value: new Date(value).toISOString() }, row];
    }
    return [{ value }, row];
  });
}

const onlyNumbers = /\D/g;

export function fieldToNumber(values: [Scalar, number][], meta: any): [IDataHookRecord, number][] {
  return values.map(([value, row]) => {
    if (!value) {
      return [{ value: 0 }, row];
    }
    const withoutSymbols = +`${value}`.replace(onlyNumbers, '');
    return [{ value: withoutSymbols }, row];
  });
}

export function fieldToPhoneNumber(values: [Scalar, number][], meta: any): [IDataHookRecord, number][] {
  return values.map(([value, row]) => {
    if (!value) {
      return [{ value: '' }, row];
    }
    return [{ value: parsePhoneNumber(value as string, 'US').number as string }, row];
  });
}

export function fieldToNumberWithDecimals(values: [Scalar, number][], meta: any): [IDataHookRecord, number][] {
  return values.map(([value, row]) => {
    if (!value) {
      return [{ value: 0 }, row];
    }
    if (typeof value === 'number' || typeof value === 'boolean') {
      return [{ value }, row];
    }
    return [{ value: parseFloat(value) }, row];
  });
}
export function fieldToBoolean(values: [Scalar, number][], meta: any): [IDataHookRecord, number][] {
  return values.map(([value, row]) => {
    if (!value) {
      return [{ value: false }, row];
    }
    let parsed = false;
    try {
      parsed = JSON.parse(`${value}`.toLowerCase());
    } catch (error) {
      // do something?
    }
    return [{ value: parsed }, row];
  });
}
